export async function fetchAvailableCities(): Promise<AvailableCitiesResponse> {
  return await $fetch<AvailableCitiesResponse>('/availabilities/cities', {
    method: 'GET',
    baseURL: useRuntimeConfig().public.apiBaseURL,
  }).catch((error) => {
    return error.data
  })
}
